import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { InformacaoService } from 'src/app/service/informacao/informacao.service';
import { ERRO_DADOS_NAO_GRAVADOS, OK_MANIFESTO_ENVIADO, ERRO_FORMULARIO_INVALIDO, MSG_OBG_NUM_PROCESSO_VALIDO } from 'src/app/tools/Mensagens';
import { PAGINA_SUCESSO_FORM } from 'src/app/tools/URL';

@Component({
  selector: 'informacao',
  templateUrl: './informacao.component.html',
  styleUrls: ['./informacao.component.css']
})
export class InformacaoComponent implements OnInit {
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  alerts: String = '';

  constructor(public service: InformacaoService,
    public authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.service.carregarDados().subscribe(retorno => {
      this.service.informacao.controls.nome.setValue(this.authService.usuarioDTO.nome);
      this.service.informacao.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.informacao.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.informacao.controls.listaCartorio.setValue(retorno.listaCartorio);
        this.service.informacao.controls.assuntos.setValue(retorno.assuntos);
        this.checarAssuntoUnico();
      }
    })
  }

  checarAssuntoUnico() {
    if (this.service.informacao.controls.assuntos.value != null && this.service.informacao.controls.assuntos.value.length == 1) {
      this.changeAssunto(this.service.informacao.controls.assuntos.value[0]);
    }
  }

  onSubmit() {
    this.validarFormulario();
    if (this.service.informacao.value.assunto) {
      this.preencherDados();
      if (this.service.informacao.valid) {

        if(this.service.informacao.controls.cartorio) {

          const cartorio = this.service.informacao.value.listaCartorio
          .find(cartorio => cartorio.nomeServico === this.service.informacao.controls.cartorio.value && cartorio.id.municipio.nome === this.service.informacao.controls.municipio.value);
          this.service.informacao.value.cartorio = cartorio;

        }

        this.service.enviar(this.service.informacao.value).subscribe(retorno => {
          if (retorno) {
            alert(OK_MANIFESTO_ENVIADO);
            this.router.navigate([PAGINA_SUCESSO_FORM]);
          } else {
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      } else {
        alert(ERRO_FORMULARIO_INVALIDO + this.alerts);
      }
    }
  }

  preencherDados() {
    this.service.informacao.controls.nome.setValue(this.authService.usuarioDTO.nome)
    this.service.informacao.controls.email.setValue(this.authService.usuarioDTO.email)
    this.service.informacao.value.files = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.informacao.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  changeAssunto(item) {
    this.service.informacao.controls.assunto.setValue(item);

    this.service.informacao.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.informacao.value.assuntos
      .filter(assunto => assunto.id === item.id)
      .forEach((assunto: any) => assunto.selected = true);

    this.service.informacao.value.assuntos
      .filter(assunto => assunto.id !== item.id)
      .forEach((assunto: any) => assunto.selected = false);

    this.resetFormControl();
  }

  resetFormControl() {
    this.service.informacao.controls.descricaoInformacao.setValue(null);
    this.service.informacao.controls.listaClassificacao.setValue([]);
    this.service.informacao.controls.numeroProcesso.disable();
    this.service.informacao.controls.tipoDeJustica.setValue(null);
    this.service.informacao.controls.localidade.setValue(null);
    this.service.informacao.controls.municipio.setValue(null);
    this.service.informacao.controls.cartorio.setValue(null);
  }

  desmarcarCheckOutrosAssuntos() {
    this.service.informacao.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);
    this.service.informacao.controls.descricaoInformacao.reset();
  }

  isChecked(item) {
    return this.service.informacao.controls.assunto.value == item;
  }

  isAssuntoChecked(str) {
    return this.service.informacao.value.assunto &&
      this.service.informacao.value.assuntos
        .filter((assunto: any) => assunto.selected && assunto.value === str)
        .length > 0 ? true : false;
  }

  validarFormulario() {
    this.alerts = '';
    switch (this.service.informacao.value.assunto.value) {
      case 'cartorios_extrajudiciais_capital_informacao': {
        this.service.informacao.controls.numeroProcesso.setErrors(null);
        this.service.informacao.controls.tipoDeJustica.setErrors(null);
        break;
      }
      case 'processo_informacao': {

        if (this.service.informacao.controls.comarca.value === null || this.service.informacao.controls.vara.value === null) {

          this.alerts += '\n' + MSG_OBG_NUM_PROCESSO_VALIDO;

        }

        this.service.informacao.controls.localidade.setErrors(null);
        this.service.informacao.controls.municipio.setErrors(null);
        this.service.informacao.controls.cartorio.setErrors(null);
        break;
      }
      case 'natureza_disciplinar_informacao': {
        this.service.informacao.controls.numeroProcesso.setErrors(null);
        this.service.informacao.controls.tipoDeJustica.setErrors(null);
        this.service.informacao.controls.localidade.setErrors(null);
        this.service.informacao.controls.municipio.setErrors(null);
        this.service.informacao.controls.cartorio.setErrors(null);
        break;
      }
      case 'servicos_acoes_adm_informacao': {
        this.service.informacao.controls.numeroProcesso.setErrors(null);
        this.service.informacao.controls.tipoDeJustica.setErrors(null);
        this.service.informacao.controls.localidade.setErrors(null);
        this.service.informacao.controls.municipio.setErrors(null);
        this.service.informacao.controls.cartorio.setErrors(null);
        break;
      }
    }
  }
}
